// Whether to simulate data instead of connecting to a real MQTT broker
export const SIMULATE = process.env.REACT_APP_SIMULATE === "true";

// GCP project the image was built for, set via docker build args (see package.json build scripts)
const GCP_PROJECT = process.env.REACT_APP_GCP_PROJECT ?? "";

// The developer tools panel can be toggled with Cmd/Ctrl+D on test builds and in local development
export const DEV_TOOLS_ENABLED =
  SIMULATE ||
  GCP_PROJECT === "mk2-test" ||
  process.env.NODE_ENV === "development" ||
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

// Optional MQTT broker override for local development, as a URL
// (e.g. "ws://192.168.1.10:8883"). Leave unset to use the default brokers.
export const MQTT_BROKER_OVERRIDE = process.env.REACT_APP_MQTT_BROKER ?? "";

// Placeholder for unavailable data
export const PLACEHOLDER = "--";

export const CONFIG_FETCH_INTERVAL_MS = 1000 * 60 * 20;

export const SYSTEM_STATUS_FETCH_INTERVAL_MS = 1000 * 3;

// GPS counts as connected while "position" messages keep arriving; after this
// long without one it is considered disconnected
export const GPS_POSITION_TIMEOUT_MS = 1000 * 10;

export const HELM_STATUS_PUBLISH_INTERVAL_MS = 1000 * 30;

export const DISCLAIMER_AUTO_HIDE_SECONDS = 30;

// How often the in-memory analytics counters are published to the device
export const ANALYTICS_PUBLISH_INTERVAL_MS = 1000 * 60;

// Set REACT_APP_ANALYTICS=false to disable plotter analytics entirely
export const ANALYTICS_ENABLED = process.env.REACT_APP_ANALYTICS !== "false";

export const AUTO_REFRESH_INTERVAL_HOURS = 24;
